// Lists used by the partner registration wizards.
export const VENDOR_TYPES = [
  { id: "supply", label: "Supply Vendor", desc: "Materials only" },
  { id: "service", label: "Service Vendor", desc: "Labour / specialised services" },
  { id: "both", label: "Both Supply & Service", desc: "Material + execution" },
];

export const MATERIAL_CATEGORIES = [
  "Cement", "Sand", "Aggregate", "Bricks", "TMT Steel",
  "Ready Mix Concrete", "Blocks / AAC Blocks", "Tiles", "Marble / Granite",
  "Paint", "Plumbing Material", "Electrical Material", "Hardware Items",
  "Plywood / Timber", "Glass", "Aluminum", "Doors / Windows",
  "Waterproofing Materials", "Chemicals / Adhesives", "False Ceiling Material",
  "HVAC Material", "Safety Equipment", "Scaffolding Material",
  "Construction Tools", "Other Material",
];

export const SERVICE_CATEGORIES = [
  "Excavation Work", "Earth Filling", "RCC Work", "Mason Work",
  "Plumbing Work", "Electrical Work", "Painting Work", "Waterproofing Work",
  "Fabrication Work", "Interior Work", "Pest Control", "Housekeeping",
  "Security Service", "Equipment Rental", "Transportation", "Crane Service",
  "Architect Support", "Labour Supply", "Surveying TS", "Piling Work",
  "Structural Fabrication", "Structural Erection", "Other Services",
];

export const PROFESSIONAL_CATEGORIES = [
  "Civil Engineer", "Architect", "Structural Engineer", "MEP Engineer",
  "Interior Designer", "Project Manager", "Quantity Surveyor",
  "Safety Officer", "Site Supervisor", "Contractor", "Consultant",
  "Valuation Expert", "Legal / Approval Consultant",
];

export const PROFESSIONAL_SKILLS = [
  "AutoCAD", "Revit", "STAAD Pro", "Primavera",
  "Estimation", "Billing", "Tendering", "Site Execution",
  "Interior Design", "Project Planning",
];

export const ENGAGEMENT_TYPES = [
  "Full Time Job", "Freelance", "Consultancy", "Project Based", "Remote Work",
];

export const VENDOR_DOC_KEYS = [
  { key: "gst_certificate", label: "GST Certificate" },
  { key: "pan_card", label: "PAN Card" },
  { key: "registration_certificate", label: "Registration Certificate" },
  { key: "cancelled_cheque", label: "Cancelled Cheque" },
  { key: "company_profile", label: "Company Profile PDF" },
  { key: "brochure", label: "Brochure / Catalogue" },
  { key: "work_orders", label: "Work Orders (sample)" },
  { key: "completion_certs", label: "Completion Certificates" },
];

export const PROFESSIONAL_DOC_KEYS = [
  { key: "resume", label: "Resume" },
  { key: "degree_certificate", label: "Degree Certificate" },
  { key: "experience_letter", label: "Experience Letter" },
  { key: "portfolio", label: "Portfolio" },
  { key: "id_proof", label: "ID Proof" },
  { key: "cancelled_cheque", label: "Cancelled Cheque" },
];

export const STATES = [
  "Andhra Pradesh", "Bihar", "Chhattisgarh", "Delhi", "Goa", "Gujarat",
  "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
  "Madhya Pradesh", "Maharashtra", "Odisha", "Punjab", "Rajasthan",
  "Tamil Nadu", "Telangana", "Uttar Pradesh", "Uttarakhand", "West Bengal",
];
